"use client"

import { ServiceUser } from "@/validated-servertypes";
import {LDClient, LDFlagSet, LDMultiKindContext} from "launchdarkly-react-client-sdk";

export async function identifyServiceUserToLaunchDarkly (su: ServiceUser, ldc: LDClient) : Promise<LDFlagSet> {

    const context: LDMultiKindContext = {
        kind: "multi",
        user: {
          key: su.principal,
          name: su.name,
        }
    }

    const ldFlags: LDFlagSet = await ldc.identify( context )

    return( ldFlags );
  }